// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--j_NMq","inner":"_93444fe79c--inner--p66kP","description-wrapper":"_93444fe79c--description-wrapper--wsTmp"};